module.exports = __webpack_public_path__ + "img/login-logo.1e0357fc.png";